// extracted by mini-css-extract-plugin
export var button = "s-module--button--28039";
export var overlay = "s-module--overlay--bd4c6";
export var text = "s-module--text--18022";
export var wrapper = "s-module--wrapper--76541";